// Module bật/tắt của tổ chức (ticket 120/121). Quy tắc quang chốt: chưa có setting => bật hết; có setting thì chỉ module
// enabled=false mới tắt; module không có trong danh sách (module mới) => bật. Tắt chỉ ẩn menu, không chặn route/API.
export type OrgModuleKey = 'events' | 'fnbpos' | 'court' | 'tournaments' | 'cms' | 'unit_ledger' | 'seating_plans';

export type OrgModules = Record<string, { enabled?: boolean } | undefined>;

export function parseOrgModules(raw: unknown): OrgModules | undefined {
  if (!raw) return undefined;
  if (typeof raw === 'string') {
    try {
      const o = JSON.parse(raw);
      return o && typeof o === 'object' ? (o as OrgModules) : undefined;
    } catch {
      return undefined;
    }
  }
  return typeof raw === 'object' ? (raw as OrgModules) : undefined;
}

export function isModuleEnabled(modules: unknown, key: OrgModuleKey): boolean {
  const m = parseOrgModules(modules);
  return m?.[key]?.enabled !== false;
}

// Phát sau khi lưu ở Cài đặt → Module để TenantContext tải lại và menu đổi ngay.
export const ORG_MODULES_CHANGED_EVENT = 'org-modules-changed';
